import React from 'react';
import { BaseField } from 'react/components/fields';
import PropTypes from 'prop-types';
import CrudContext from 'react/contexts/DefaultContext';

class LookupField extends React.Component {
  constructor(props) {
    super(props);
    const { name, lookupEntityColumn, monetMeta } = props;
    const hasManyEntity = monetMeta?.hasMany?.entityName;
    const fields = hasManyEntity ? [
      'id', `${hasManyEntity}.id`, `${hasManyEntity}.${lookupEntityColumn}`
    ] : [
      'id', lookupEntityColumn
    ];
    this.state = {
      monetField: null,
      fieldCriteria: fields.map((column) => `${name}.${column}`)
    };
  }

  componentDidMount() {
    const {
      name,
      lookupEntity,
      lookupEntityColumn,
      multiple,
      monetMeta
    } = this.props;

    const { entity } = this.context;
    this.setState({
      monetField: new Monet.UI.Fields.Render({
        name: name.replace(/\[|\]|\./g, ''),
        lookupEntity,
        lookupEntityColumn,
        type: multiple ? 'LOOKUP_LIST' : 'LOOKUP',
        meta: monetMeta
      }, entity).render()
    });
  }

  gridFormatter = () => {
    const {
      label,
      name,
      multiple,
      lookupEntity,
      lookupEntityColumn,
      monetMeta
    } = this.props;

    return {
      id: name,
      name,
      label,
      type: multiple ? 'LOOKUP_LIST' : 'LOOKUP',
      lookupEntity,
      lookupEntityColumn,
      meta: monetMeta
    };
  };

  renderFieldContent = ({
    input,
    monetField,
    ref,
    disabled
  }) => {
    const {
      multiple,
      customCriteriaChain
    } = this.props;

    if (monetField) {
      const onChange = () => {
        const value = multiple ? monetField.getValue() : monetField.getFullValue();
        if (value && (value.id || value.length)) {
          if (multiple) {
            input.onChange([...value]);
          } else if (value.id) {
            input.onChange({ ...value });
          }
        } else {
          input.onChange(null);
        }
      };

      if (customCriteriaChain) {
        monetField.setCustomCriteriaChain(customCriteriaChain);
      }

      monetField.setValue(input.value, { cleanChange: true, doNotTriggerChange: true });

      if (disabled) {
        monetField.disable();
      } else {
        monetField.enable();
      }

      monetField.setOnBlur(input.onBlur);
      monetField.setOnFocus(input.onFocus);
      monetField.setOnChange(onChange);
    }

    return (
      <div ref={ref} />
    );
  }

  customValidation = (values) => {
    const { multiple, required } = this.props;
    if (required && (!values || (multiple && !values.length))) {
      return 'general.mandatoryField';
    }
    return undefined;
  }

  render() {
    const { monetField, fieldCriteria } = this.state;
    return (
      <BaseField
        fieldClassName="lookupField"
        monetField={monetField}
        renderFieldContent={this.renderFieldContent}
        customValidation={this.customValidation}
        gridFormatter={this.gridFormatter}
        fieldCriteria={fieldCriteria}
        {...this.props}
      />
    );
  }
}

LookupField.contextType = CrudContext;

LookupField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  lookupEntity: PropTypes.string.isRequired,
  lookupEntityColumn: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  monetMeta: PropTypes.object,
  customCriteriaChain: PropTypes.array
};

LookupField.defaultProps = {
  multiple: false,
  disabled: false,
  required: false,
  monetMeta: null,
  customCriteriaChain: null
};

export default LookupField;
